// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import { AppIcon } from '@loa/ui-components';

export function EyeIcon() {
  return <AppIcon name="eye" size={16} color="#2D0A6C" />;
}

export function DownloadIcon() {
  return <AppIcon name="download filled" size={16} color="#2D0A6C" />;
}

export function UploadIcon() {
  return <AppIcon name="upload" size={16} color="#2D0A6C" />;
}

export function BanIcon() {
  return <AppIcon name="ban" size={16} color="#2D0A6C" />;
}

export function TrashIcon() {
  return <AppIcon name="trash" size={16} color="#2D0A6C" />;
}

export function SliceEyeIcon() {
  return <AppIcon name="eye" size={16} color="#2D0A6C" />;
}

export function SliceDownloadIcon() {
  return <AppIcon name="download filled" size={16} color="#2D0A6C" />;
}

/**
 * Rounded chevron-down used as the dropdown affordance on outlined buttons
 * (e.g. the "Nudge Outstanding" menu). Rendered as a raw SVG because the
 * shared AppIcon set has no matching rounded chevron.
 */
export function ChevronDownIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      data-testid="chevron-down-icon"
      aria-hidden="true"
    >
      <path
        d="M19.7441 8.77344C19.8389 8.6787 20.0019 8.67871 20.0967 8.77344C20.1914 8.86818 20.1914 9.03124 20.0967 9.12598L13.5771 15.6465C13.1442 16.0793 12.5727 16.2997 12.001 16.2998C11.429 16.2998 10.8569 16.0794 10.4238 15.6465L3.9043 9.12598C3.80956 9.03124 3.80956 8.86818 3.9043 8.77344C3.99903 8.6787 4.1621 8.6787 4.25684 8.77344L10.7773 15.293C11.4526 15.9681 12.5484 15.9681 13.2236 15.293L19.7441 8.77344Z"
        fill="#141414"
        stroke="#2D0A6C"
      />
    </svg>
  );
}
